import React from "react";
import FallBackLoader from "../components/FallBackLoader";
import { useFetchUserProfile } from "../hooks/useQuery/useUserProfile";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useWebSettings } from "../hooks/useQuery/useWebsiteSettings";
import { WebRoutes } from "../routes/WebRoutesPath";
import { decodeCookie } from "../utils/decodeCookie";

const AuthenticateUser = () => {
  const maxAge = "max-age=86400";
  const { search } = useLocation();
  const { setToken, setCurrentUser } = useAuth();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const userToken = search
    ? search.split("&token=")[1]
    : JSON?.parse(
        decodeCookie(
          process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
        ).slice(1)
      );
  document.cookie = `${process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY}=${userToken};${maxAge};`;
  document.cookie = `tripbuilder=${userToken};${maxAge}; domain=tripmerchant.com;`;

  setToken(userToken);
  const { isLoading, data: userData } = useFetchUserProfile();
  const { isLoading: settingsLoading, data: webSettings } = useWebSettings(
    userData?.data?.organization?.uuid
  );
  if (isLoading || settingsLoading) {
    return (
      <FallBackLoader
        title={isLoading ? "Authenticating User ..." : "Loading User Settings"}
      />
    );
  } else if (
    userData?.data &&
    userData?.status === 1 &&
    webSettings?.data &&
    webSettings?.status === 1
  ) {
    document.cookie = `${
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
    }=${JSON.stringify(userData?.data)} ; ${maxAge};`;

    setCurrentUser(userData?.data);
    const redirectPath = params.get('redirect');
    navigate(redirectPath? redirectPath : '/');
  } else navigate(WebRoutes.WebNotFound);
};

export default AuthenticateUser;
